"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkScheduleSlotsListApiResponseSchema = exports.getWorkScheduleSlotItemApiSchema = void 0;
const zod_1 = require("zod");
const agenda_slot_1 = require("../agenda-slots/agenda-slot");
const api_1 = require("../global/api");
const event_schema_1 = require("../global/event.schema");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const work_schedule_slot_1 = require("./work-schedule-slot");
exports.getWorkScheduleSlotItemApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('work-schedule-slots'),
    attributes: zod_1.z.object({
        startAt: zod_1.z.coerce.date(),
        endAt: zod_1.z.coerce.date(),
        rrule: event_schema_1.agendaRruleSchema,
        exdate: zod_1.z.array(zod_1.z.string()).optional().default([]),
        sourceId: zod_1.z.string().uuid().nullable().default(null),
        slotType: agenda_slot_1.agendaSlotTypeSchema.optional().default(agenda_slot_1.PRESENTIEL_SLOT_TYPE),
        withAssistante: zod_1.z.coerce.boolean(),
        forceWithoutAssistant: zod_1.z.boolean(),
        dayOfWeek: zod_1.z.enum(event_schema_1.daysOfWeek),
        periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
        occurenceIndex: zod_1.z.number().optional(),
        createdAt: zod_1.z.coerce.date(),
        updatedAt: zod_1.z.coerce.date(),
        medicalAssistantWorkDuration: zod_1.z.number().optional(),
        medicalAssistantWorkPeriods: zod_1.z
            .array(zod_1.z.object({
            startTime: zod_1.z.coerce.date(),
            endTime: zod_1.z.coerce.date(),
            date: zod_1.z.coerce.date(),
        }))
            .optional(),
        /**
         * Computed medical-assistant work periods overlapping the slot (day-boundary
         * extended, pauses removed, Formation excluded), resolved server-side.
         * Preferred over the legacy Skello `medicalAssistantWorkPeriods`.
         */
        assistantPeriods: zod_1.z
            .array(zod_1.z.object({
            assistantId: zod_1.z.string().uuid(),
            userId: zod_1.z.string(),
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            startTime: zod_1.z.string(),
            endTime: zod_1.z.string(),
            durationMinutes: zod_1.z.number(),
        }))
            .optional(),
        reconciliationWarningType: zod_1.z.string().nullable().optional(),
        tag: zod_1.z.string().optional(),
    }),
    relationships: zod_1.z
        .object({
        doctorAttending: (0, api_1.apiEntityRelationshipSchema)('doctor-attendings').optional(),
        sequence: (0, api_1.apiEntityRelationshipSchema)('work-schedule-slots').optional(),
    })
        .optional()
        .default({}),
});
exports.getWorkScheduleSlotsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getWorkScheduleSlotItemApiSchema).merge(zod_1.z.object({
    included: zod_1.z
        .array(zod_1.z.union([
        work_schedule_slot_1.workScheduleSlotDoctorAttendingApiSchema,
        work_schedule_slot_1.workScheduleSlotSequenceApiSchema,
    ]))
        .optional()
        .default([]),
}));
